import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import FlatButton from 'material-ui/FlatButton';
import { colors } from 'helpers/ColorHelper';

import * as tenantProfileActions from 'actions/tenantProfileActions';
import { explosionCelebration } from 'actions/notificationActions';
import { getTenantTodoList } from 'actions/todoActions';

import { formatMoney } from 'helpers/Formatter';
import { AccentColor } from 'helpers/AccentColorHelper';
import StripePayment from 'components/shared/StripePayment';

import autopayIconPath from 'assets/autopay.svg';
import creditCardIconPath from 'assets/creditcard.svg';
import { getTranslatedString } from 'helpers/i18n';
import { getTenancyStatus } from 'actions/dashboardActions';
import YardiLedger from './shared/YardiLedger';

const DialogHeaderText = styled.h3`
  margin: 10px 0 5px;
  text-align: center;
`;

const TotalBalance = styled.div`
  border-top: 1px solid ${colors.OFF_WHITE};
  margin: 25px 0;
  text-align: center;
  padding-top: 25px;
`;

const TotalBalanceAmount = styled.div`
  font-size: 24px;
  font-family: 'Circular-Black';
`;

const PaymentOption = styled.div`
  margin: 15px auto;
  width: 210px;
  text-align: center;
  cursor: pointer;
  &:hover {
    transform: scale(1.05);
    transition: transform ease 300ms;
  }
`;

const PaymentOptionTitle = styled.div`
  font-size: 18px;
  font-family: 'Circular-Black';
  margin-top: 15px;
`;

let YardiPayDialog = class YardiPayDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentDialogOpen: false,
    };
  }

  deleteByVal(val, obj) {
    for (const key in obj) {
      if (obj[key] === val) delete obj[key];
    }
  }

  togglePaymentDialog = () => {
    this.setState({ paymentDialogOpen: !this.state.paymentDialogOpen });
  };

  handleToken = (token, paymentAmount) => {
    return this.props.makeCustomAmountPayment(token, paymentAmount).then(() => {
      this.props.explosionCelebration();
      this.props.getTenantTodoList();
      this.props.getTenancyStatus();
      this.props.payments();
      this.props.toggleDialog();
      this.togglePaymentDialog();
    });
  };

  render() {
    const data = this.props.paymentDetails || { historic_payments: [] };
    const paymentDetails = data.payment_details || [];
    const tenantOverview = this.props.tenantOverview || {};
    const ledger = this.props.ledger || [];
    const lastLedgerEntry = ledger[ledger.length - 1];
    const balance = lastLedgerEntry && lastLedgerEntry.balance;
    this.deleteByVal('$0.00', paymentDetails);

    const style = {
      table_header: {
        margin: '5px -20px 10px -20px',
        backgroundColor: '#f1f1f1',
        padding: '5px 10px',
        fontSize: '14px',
        fontWeight: '800',
      },
    };

    return (
      <div>
        <StripePayment
          customAmount
          open={this.state.paymentDialogOpen}
          toggleOpen={this.togglePaymentDialog}
          pricing={data.pricing_object}
          onToken={this.handleToken}
          fullScreen={this.props.fullScreen}
        />
        <Dialog
          open={this.props.isOpen}
          onClose={this.props.toggleDialog}
          aria-labelledby="payment-details-dialog"
          classes={{ paper: 'form-dialog' }}
          fullScreen={this.props.fullScreen}
        >
          <DialogTitle id="payment-details-dialog">
            <DialogHeaderText>{getTranslatedString('makeAPayment')}</DialogHeaderText>
          </DialogTitle>
          <DialogContent>
            {tenantOverview.use_payment_platform && (
              <Fragment>
                <div className="row" style={style.table_header}>
                  <h4 style={{ margin: '0', textAlign: 'center' }}>
                    {getTranslatedString('paymentOptions')}
                  </h4>
                </div>
                <div className="row">
                  <div
                    className={`col-xs-12 col-md-${data.status === 'Autopay' ? '12' : '6'}`}
                    onClick={this.togglePaymentDialog}
                  >
                    <PaymentOption>
                      <div>
                        <img alt="credit card icon" src={creditCardIconPath} />
                      </div>
                      <PaymentOptionTitle>
                        {getTranslatedString('tenantPortal.yardiPayDialog.payWithCreditCard')}
                      </PaymentOptionTitle>
                      {getTranslatedString('tenantPortal.yardiPayDialog.payWithCreditCardExplain')}
                    </PaymentOption>
                  </div>
                  {data.status !== 'Autopay' && (
                    <div className="col-xs-12 col-md-6" onClick={this.props.toggleAutopay}>
                      <PaymentOption>
                        <div>
                          <img alt="Autopay Icon" src={autopayIconPath} />
                        </div>
                        <PaymentOptionTitle>
                          {getTranslatedString('tenantPortal.yardiPayDialog.payWithAutopay')}
                        </PaymentOptionTitle>
                        {getTranslatedString('tenantPortal.yardiPayDialog.payWithAutopayExplain')}
                      </PaymentOption>
                    </div>
                  )}
                </div>
              </Fragment>
            )}

            <TotalBalance>
              <TotalBalanceAmount>{formatMoney(balance)}</TotalBalanceAmount>
              <div>{getTranslatedString('tenantPortal.yardiPayDialog.totalBalance')}</div>
            </TotalBalance>

            <YardiLedger ledger={ledger} />
          </DialogContent>
          <DialogActions style={{ display: 'block' }}>
            <FlatButton
              onClick={this.props.toggleDialog}
              id="close-button"
              style={{ color: AccentColor() }}
            >
              {getTranslatedString('close')}
            </FlatButton>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
};

export default withMobileDialog()(
  connect(
    store => {
      return {
        tenantOverview: store.dashboard.tenantOverview,
      };
    },
    { ...tenantProfileActions, getTenantTodoList, explosionCelebration, getTenancyStatus }
  )(YardiPayDialog)
);
